export class ICustomerProductReview {
    id: number;
    customerId: number;
    productId: number;
    rating: number;

    constructor() {
        this.id = null;
        this.customerId = null;
        this.productId = null;
        this.rating = null;
    }

}

export class IShow {
    value: boolean;
    constructor() {
        this.value = false;
    }
}

export class IProductSummary {

    rating: number;
    ratingCountDisplay: string;
    roundedRating: number;

    constructor() {
        this.rating = null;
        this.ratingCountDisplay = null;
        this.roundedRating = null;

    }

}
